import * as React from 'react';

import { PromoInfo } from '../PromoInfo';
import { PromoModalWrapper } from '../PromoModalWrapper';

interface IPromoModalProps {
  description?: string | null;
  endDate: string;
  name: string;
  villageName?: string | null;
  villageLogoUrl?: string | null;
  closeModal(): void;
  open: boolean;
  phoneButton: React.ReactNode;
}

export function PromoModal({
  open,
  closeModal,
  name,
  endDate,
  description,
  villageLogoUrl,
  villageName,
  phoneButton,
}: IPromoModalProps) {
  return (
    <PromoModalWrapper title={name} open={open} onClose={closeModal}>
      <PromoInfo
        endDate={endDate}
        description={description}
        villageLogoUrl={villageLogoUrl}
        villageName={villageName}
      />
      {phoneButton}
    </PromoModalWrapper>
  );
}
